import dayjs from "dayjs"
import { DATE_FORMAT } from "./constants"

export const bidsCardDefaultValues = {
    businessUnitId: 0,
    rfqType: [],
    rfqNo: [],
    rfqDeadline: '',

    enteredBy: '',
    bidNo: '',
    rfqMainId: 0,
    comparisonNo: '',
    orderNo: '',

    entryDate: '',
    desiredDeliveryDate: '',
    requiredOnSiteDate: '',
    rfqDate: '',

    operatorComment: '',
    placeOfDelivery: '',
    sentDate: '',
    emergency: 0,

    vendorCode: '',
    vendorName: '',
    address: '',
    contact: '',
    email: '',
    country: '',
    phone: '',
    taxId: '',
    taxCode: '',

    currencyCode: 'AZN',
    discountType: 0, // []
    discountValues: 0,
    deliveryTerms: '',
    deliveryTime: '',
    paymentTerms: '',
    expectedCost: '',

    status: 0,
    approvalStatus: 0,
    totalPriceBase: 0,
    discountedPriceBase: 0,
    attachments: []
  }


  export const bidsInitialMainFilter = {
    businessUnitId: 0,
    emergency: [-1],
    dateFrom: dayjs().subtract(12, 'month').format(DATE_FORMAT),
    dateTo: dayjs().format(DATE_FORMAT), 
    approveStatus: [-1],
    status: [-1],
  }